// Truy vấn dùng chung của khung project (Work / Build). Khoá luôn qua factory `qk` (W.2: workspace + scopeVersion).
import { qk, STALE_TIME } from "@secretaa/sdk-react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../app/api.ts";
import { useCurrentWorkspace } from "../../app/session.ts";

export function useProject(projectId: string) {
  const cur = useCurrentWorkspace()!;
  return useQuery({ queryKey: qk.project(cur.tenant, projectId), queryFn: async () => ({ data: await api.projects.get(cur.workspaceId, projectId) }), staleTime: STALE_TIME.projectDefinition });
}

/** Blueprint active + manifest (runtime chỉ đọc manifest — ADR-001 mục 9). Khoá đổi theo scopeVersion; version đổi ⇒ invalidate. */
export function useBlueprint(projectId: string) {
  const cur = useCurrentWorkspace()!;
  return useQuery({ queryKey: qk.blueprint(cur.tenant, projectId), queryFn: () => api.blueprint.get(cur.workspaceId, projectId), staleTime: STALE_TIME.projectDefinition });
}

export function useScopes(projectId: string) {
  const cur = useCurrentWorkspace()!;
  return useQuery({ queryKey: qk.scopes(cur.tenant, projectId), queryFn: () => api.scopes.list(cur.workspaceId, projectId), staleTime: STALE_TIME.projectDefinition });
}

export type ProjectRole = "viewer" | "editor" | "manager";
const RANK: Record<ProjectRole, number> = { viewer: 1, editor: 2, manager: 3 };

/**
 * Vai trò có đủ cho thao tác không (ADR-010: sửa dữ liệu ⇒ editor; đổi tên / lưu trữ / khôi phục, Build, thành viên ⇒
 * manager). CHỈ để GỢI Ý trước khi bấm — quyết định người dùng 2026-10-22 (SAA-2026-012): không ẩn, không khoá nút theo
 * vai trò; server là nơi chặn (404 / 403) và câu từ chối nói rõ cần vai trò gì.
 */
export const roleMeets = (role: ProjectRole | null | undefined, needs: ProjectRole) => role != null && RANK[role] >= RANK[needs];
